import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { IconButton, Stack } from "@mui/material";
import { SafeDatePicker } from "components/SafeDatePicker";
import { Dayjs } from "dayjs";
import { useTenantTranslation } from "hooks/formatters";
import { parseDateParam } from "hooks/useDayjsDateStringParamState";

export const parseLocalDateParam = (
  param: string | null,
  localTimezone: string,
  fallback: Dayjs
): Dayjs => {
  const parsedDate = param ? parseDateParam(param, localTimezone) : null;
  return parsedDate?.isValid() ? parsedDate : fallback;
};

export const PeriodStepper = ({
  value,
  onChange,
  unit,
  maxDate,
}: {
  value: Dayjs;
  onChange: (date: Dayjs) => void;
  unit: "day" | "month";
  maxDate: Dayjs;
}) => {
  const { t } = useTenantTranslation();
  return (
    <Stack direction="row" spacing={0} alignItems="center">
      <IconButton
        aria-label={t("previous")}
        size="small"
        sx={{ color: "text.secondary", height: 34, width: 34 }}
        onClick={() => {
          onChange(value.subtract(1, unit));
        }}
      >
        <ChevronLeftIcon />
      </IconButton>
      <SafeDatePicker
        label={unit === "month" ? t("month") : t("date")}
        value={value}
        views={unit === "month" ? ["month", "year"] : undefined}
        onChange={(newValue) => {
          if (newValue) {
            onChange(newValue);
          }
        }}
        maxDate={maxDate}
        slotProps={{ textField: { size: "small" } }}
      />
      <IconButton
        aria-label={t("next")}
        size="small"
        sx={{ color: "text.secondary", height: 34, width: 34 }}
        onClick={() => {
          onChange(value.add(1, unit));
        }}
        disabled={!value.isBefore(maxDate, unit)}
      >
        <ChevronRightIcon />
      </IconButton>
    </Stack>
  );
};
